export default class PageManager {
  constructor(context) {
    this.context = context;
  }

  type() {
    return this.constructor.name;
  }

  onReady() {}

  static load(context) {
    const page = new this(context);

    $(document).ready(() => {
      if (window.location.pathname === "/") {
        window.location.href = "/all-products";
      }
      page.onReady.bind(page)();
    });
  }
}
